import { useState } from "react";

interface CommentItemProps {
  name: string;
  time: string;
  initial: string;
  text: string;
  likes: number;
  replies: number;
}

export default function CommentItem({ name, time, initial, text, likes, replies }: CommentItemProps) {
  const [liked, setLiked] = useState(false);
  const [count, setCount] = useState(likes);

  const toggleLike = () => {
    const next = !liked;
    setLiked(next);
    setCount((c) => c + (next ? 1 : -1));
  };

  return (
    <article className="flex gap-3.5 border-b border-background-200 py-5 last:border-b-0 md:gap-4">
      <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-900">
        {initial}
      </span>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span className="font-label text-sm font-medium text-foreground-900">{name}</span>
          <span className="font-label text-xs text-foreground-400">{time}</span>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-foreground-700">{text}</p>
        <div className="mt-3 flex items-center gap-5">
          <button
            type="button"
            onClick={toggleLike}
            className={`flex cursor-pointer items-center gap-1.5 font-label text-xs transition-colors duration-200 ${
              liked ? "text-accent-600" : "text-foreground-500 hover:text-foreground-800"
            }`}
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className={liked ? "ri-heart-3-fill text-sm" : "ri-heart-3-line text-sm"} />
            </span>
            {count}
          </button>
          <span className="flex items-center gap-1.5 font-label text-xs text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-chat-3-line text-sm" />
            </span>
            {replies} 条回复
          </span>
        </div>
      </div>
    </article>
  );
}